import { useTheme } from '@mui/material/styles';
import { colors } from '../../../../theme/colors';

export function useLightestOutline() {
  const theme = useTheme();
  // Design: outline/lightest
  return theme.palette.mode === 'dark'
    ? theme.palette.divider
    : colors.neutral[100];
}
